import {createAction, props} from "@ngrx/store";
import {Serializers} from "../../interfaces/serializer";
import {MatchingDataSourceAd} from "../../interfaces/matching";

export const loadDataSourcesAd = createAction('[DATA_SOURCES_AD] LOAD');
export const loadDataSourcesAdSuccess = createAction('[DATA_SOURCES_AD] LOAD_SUCCESS', props<{ dataSources: Serializers<MatchingDataSourceAd> }>());
